import { Component, signal, OnInit } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { ManageUsersService } from '../manage-users/manage-users.service';
import { UtilService } from 'src/app/shared/helper/util.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { LibMultiSelectComponent } from '../lib-multi-select/lib-multi-select.component';
import { last } from 'lodash';
import { SelectionGroup } from 'src/app/shared/request-access-dialog/request-access-dialog.component';
import { A11yModule } from "@angular/cdk/a11y";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { ManageModuleService } from './manage-module.service';
import { ManageRequestsService } from '../manage-requests/manage-requests.service';

// Interface for module items displayed in the table and used in edit form
export interface ModuleItem {
  id: number;
  moduleType: string;
  moduleName: string;
  moduleOwnerEmail: string;
  moduleBrief: string;
  moduleDescription: string;
  moduleFeatures: string[];
  moduleLink: string;
  moduleImagePath: string;
  moduleApiLink: string;
  moduleIdentityToken: string;
  moduleCallbackEndpoint: string;
  report: string;
  group: string;
  additionalGroup: string;
  businessLine: string;
  category: string;
  function: string;
  productLine: string;
  region: string;
  roleName: string;
  tagId: string;
  isInternal: boolean;
  isMultimodal: boolean;
  instantProcessing: boolean;
  status: string;
  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string;
  accessGroups: { groupName: string; groupDescription: string }[];
}

// Interface for request items (kept for legacy support)
interface RequestItem {
  id: number;
  reqID: string;
  requestedCategory: string;
  requestedModule: string;
  submittedByName: string;
  submittedByEmail: string;
  org: string;
  lastUpdated: string;
  status: string;
  notes?: string;
  requestedUserGroups: string[];
  selectedSubscriptionId?: number;
}

// Interface for subscription items
interface SubscriptionItem {
  id: number;
  name: string;
  description: string;
  createdOn: string;
  expiryDate: string;
}

@Component({
    selector: 'app-manage-modules',
    templateUrl: './manage-modules.component.html',
    styleUrl: './manage-modules.component.scss',
    standalone: false
})

export class ManageModulesComponent implements OnInit {
  searchTerm: string = '';
  isFilterOpen: boolean = false;
  openDropdownKey: string | null = null;
  selectedStatus = signal<string[]>(['All']);
  selectedCategory = signal<string[]>(['All']);
  editIconBtn = '../assets/images/users/edit-icon.svg';
  
  // Tooltip state for copy-to-clipboard
  showTooltip: boolean = false;
  tooltipMessage: string = 'Copy email';
  tooltipEmail: string = '';
  tooltipTimeout: any;

  // Pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;

  // Popup properties
  isPopupOpen: boolean = false;
  selectedRequest: RequestItem | null = null;

  // Create Module Modal properties
  isCreateModuleModalOpen: boolean = false;
  selectedModuleTypeForCreate: string | null = null;

  // Module type options for create modal (matches categoryOptions)
  moduleTypeOptionsForCreate = [
    { id: 1, name: 'Data Product', icon: '../../../../assets/images/data_request_manager_icon.svg' },
    { id: 2, name: 'Application', icon: '../../../../assets/images/applications_icon.svg' },
    { id: 3, name: 'Dashboard', icon: '../../../../assets/images/analyticsIcon.svg' }
  ];

  // New subscription form properties
  isCreatingNewSubscription: boolean = false;
  newSubscriptionForm = {
    name: '',
    description: '',
    createdOn: '',
    expiryDate: ''
  };

  // Available user group options for selection
  allUserGroupOptions = ['AGB-TC', 'ARB-TC', '2WH-TC', 'B2B-AG'];

  filterForm: FormGroup = this.fb.group({
    status: ['All'],
    updatedOn: [''],
  });
  categoryTypeFilterDropdownSettings: IDropdownSettings = {};  
  statusFilterDropdownSettings: IDropdownSettings = {};

  dataRequestForm: any;
  updatedOn = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  maxDate: Date = new Date();
  headerIds: any[]=[];
  statusIds: any[]=[];
  errorFlag: boolean = false;
  isAscending: boolean = false;
  activeSortIndex: null;
  sortByValue: string = 'updated_date';
  sortTypeValue: string = 'desc';
  minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  page: number = 1;
  isAdvancedFilter: boolean;
  filterData: any;
  pendingItemsCount: any;
  userId: any;
  errMsg: any;
  showErrorMessageWithPopup: boolean;
  successMessage:any='';
  error: any = '';
  columns: string[] = ['Module Header','Module Type', 'Module Name', 'Updated By', 'Updated On', 'Status', 'Actions'];
  statusTypeId: number = 7;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private manageModuleService: ManageModuleService, 
    private homePageService: HomePageService,
    private manageRequestsService: ManageRequestsService
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.settingForStatusDropdown();
    this.settingForCategoryDropdown();
    this.getAllStatuses();
    this.getAllHeaderCategory();
    this.getManageModuleDetailsList();
  }
  buildForm() {
        this.dataRequestForm = this.fb.group({
          categoryType: new FormControl([]),
          updatedOn: this.updatedOn,
          statusType: new FormControl([]), 
        });
  }
  settingForCategoryDropdown() {
    this.categoryTypeFilterDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'headerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
  }
  settingForStatusDropdown() {
      this.statusFilterDropdownSettings = {
        singleSelection: false,
        idField: 'statusId',
        textField: 'statusName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false,
      };
  }
   getAllStatuses() {
    this.manageRequestsService.getAllStatus(this.statusTypeId).subscribe((res: any) => {
      this.statusOptions = res.result;
    })
  }
 

  // Handle search input changes
   onSearchChange(): void {
    this.currentPage = 1; // Reset to first page when search changes
    this.onAdvancedFilter();
  }

  // Handle status selection changes
  onStatusSelectionChange(selectedStatuses: string[]): void {
    this.selectedStatus.set(selectedStatuses);
    this.currentPage = 1; // Reset to first page when filter changes
  }

  // Handle category selection changes
  onCategorySelectionChange(selectedCategories: string[]): void {
    this.selectedCategory.set(selectedCategories);
    this.currentPage = 1; // Reset to first page when filter changes
  }

  statusOptions:any[] = [];

  categoryOptions: any[] = [];


  toggleFiltersCont() : void {
    this.isFilterOpen = !this.isFilterOpen;
  }

  resetAllFilters() {
    this.isAdvancedFilter = false;
    this.searchTerm = '';
    this.dataRequestForm.get('categoryType')?.setValue([]);
    this.dataRequestForm.get('statusType')?.setValue([]);

    this.updatedOn.reset();
    this.updatedOn.get('startDate')?.setValue(null);
    this.updatedOn.get('endDate')?.setValue(null);
    this.headerIds = [];
    this.statusIds = [];
    this.errorFlag = false;
    this.isAscending = false;
    this.activeSortIndex = null;
    this.sortByValue = '';
    this.sortTypeValue = '';
    this.page = 1;
    this.getManageModuleDetailsList();
  }

 

  // Get total count of active filters
  getActiveFiltersCount(): number {
    let count = 0;
    if (this.selectedStatus().length > 0 && !this.selectedStatus().includes('All')) {
      count += this.selectedStatus().length;
    }
    if (this.selectedCategory().length > 0 && !this.selectedCategory().includes('All')) {
      count += this.selectedCategory().length;
    }
    return count;
  }

  // getPaginatedStartIndex(): number {
  //   if (this.filteredTotalItems === 0) return 0;
  //   return (this.currentPage - 1) * this.itemsPerPage + 1;
  // }

  // getPaginatedEndIndex(): number {
  //   const endIndex = this.currentPage * this.itemsPerPage;
  //   return endIndex > this.filteredTotalItems ? this.filteredTotalItems : endIndex;
  // }

  // onMultiSelectDropdownToggle(key: string) {
  //   this.openDropdownKey = this.openDropdownKey === key ? null : key;
  // }

 
  // getPageNumbers() {
  //   const totalPages = Math.ceil(this.filteredTotalItems / this.itemsPerPage);
  //   return Array.from({ length: totalPages }, (_, i) => i + 1);
  // }

  // Copy email to clipboard functionality
  showCopyTooltip(email: string, event: MouseEvent): void {
    this.tooltipEmail = email;
    this.tooltipMessage = 'Copy email';
    this.showTooltip = true;
  }

  hideCopyTooltip(): void {
    this.showTooltip = false;
    this.tooltipEmail = '';
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
  }

  copyEmailToClipboard(email: string, event: MouseEvent): void {
    event.stopPropagation();
    navigator.clipboard.writeText(email).then(() => {
      this.tooltipMessage = 'Copied';
      this.showTooltip = true;
      
      // Hide tooltip after 2 seconds
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      this.tooltipTimeout = setTimeout(() => {
        this.showTooltip = false;
        this.tooltipEmail = '';
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy email:', err);
    });
  }

  metadata: { [key: string]: string } = {};
  selectionGroups: SelectionGroup[] = [];

  getMetadataKeys(): string[] {
    return Object.keys(this.metadata);
  }

  hasMetadata(): boolean {
    return Object.keys(this.metadata).length > 0;
  }

  // Navigate to edit module page
  openRequestDetailsPopup(request: any): void {
    this.router.navigate(['/manage-module', request.id]);
  }

  // // Get module by ID (for sharing data with edit component)
  // getModuleById(id: number): ModuleItem | undefined {
  //   return this.moduleList.find(m => m.id === id);
  // }

  // Close popup
  closePopup(): void {
    this.isPopupOpen = false;
    this.selectedRequest = null;
    this.metadata = {};
  }

  // Handle subscription selection from radio button
  onSubscriptionSelect(subscriptionId: number): void {
    if (this.selectedRequest) {
      this.selectedRequest.selectedSubscriptionId = subscriptionId;
      console.log('Selected subscription ID:', subscriptionId, 'for request:', this.selectedRequest.reqID);
    }
  }

  // Check if a user group is currently selected for the request
  isUserGroupSelected(userGroup: string): boolean {
    return this.selectedRequest?.requestedUserGroups?.includes(userGroup) || false;
  }

  // Toggle user group selection for the current request
  toggleUserGroup(userGroup: string): void {
    if (!this.selectedRequest) {
      return;
    }

    if (!this.selectedRequest.requestedUserGroups) {
      this.selectedRequest.requestedUserGroups = [];
    }

    const index = this.selectedRequest.requestedUserGroups.indexOf(userGroup);
    if (index > -1) {
      // Remove the user group
      this.selectedRequest.requestedUserGroups.splice(index, 1);
      console.log('Removed user group:', userGroup, 'from request:', this.selectedRequest.reqID);
    } else {
      // Add the user group
      this.selectedRequest.requestedUserGroups.push(userGroup);
      console.log('Added user group:', userGroup, 'to request:', this.selectedRequest.reqID);
    }
  }

  // Legacy methods removed - no longer needed for manage-modules

  createModuleStart_Popup() {
    this.isCreateModuleModalOpen = true;
    this.selectedModuleTypeForCreate = null;
  }

  closeCreateModuleModal(): void {
    this.isCreateModuleModalOpen = false;
    this.selectedModuleTypeForCreate = null;
  }

  selectModuleTypeForCreate(moduleType: string): void {
    this.selectedModuleTypeForCreate = moduleType;
  }

  confirmCreateModule(): void {
    if (!this.selectedModuleTypeForCreate) {
      return;
    }

    // Get current user name from localStorage or default
    const currentUserName = localStorage.getItem('userName') || 'Current User';
    const currentDate = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

    // Create module metadata to pass to edit-module component
    const moduleMetadata = {
      moduleType: this.selectedModuleTypeForCreate,
      createdBy: currentUserName,
      createdOn: currentDate,
      updatedBy: currentUserName,
      updatedOn: currentDate,
      status: 'Inactive'
    };

    this.isCreateModuleModalOpen = false;
    this.router.navigate(['/create-module'], { 
      state: { moduleMetadata } 
    });
  }

  ////
onCategorySelect(item: any) {
  const selected = this.dataRequestForm.get('categoryType')?.value || [];
  this.headerIds = selected.map((x: any) => x.id);
  this.onAdvancedFilter();
}
onCategoryDeselect(item: any) {
  const selected = this.dataRequestForm.get('categoryType')?.value || [];
  this.headerIds = selected.map((x: any) => x.id);
  this.onAdvancedFilter();
}

onSelectAllCategoryTypes(items: any) {
    this.dataRequestForm.get('categoryType')?.setValue(items);
      this.headerIds = items.map((x: any) => x.id);
      this.onAdvancedFilter();
}
onDeSelectAllCategoryTypes(items: any) {
  this.dataRequestForm.get('categoryType')?.setValue([]);
  this.headerIds = [];
  this.onAdvancedFilter();
}

  onStatusSelect(item: any) {
      const control = this.dataRequestForm.get('statusType') as FormControl;
      const current = control.value || [];
      if (!current.find((i: any) => i.statusId === item.statusId)) {
        control.setValue([...current, item]);
      }
      this.statusIds = control.value.map((i: any) => i.statusName);
      this.onAdvancedFilter();
  }
   
   onStatusDeselect(item: any) {
    const selected = this.dataRequestForm.get('statusType')?.value || [];
    this.statusIds = selected.map((x: any) => x.statusName);
    this.onAdvancedFilter();
  }
onSelectAllStatusTypes(items: any) {
  this.dataRequestForm.get('statusType')?.setValue(items);
  this.statusIds = items.map((x: any) => x.statusName);
  this.onAdvancedFilter();
}

onDeSelectAllStatusTypes(items: any) {
  const control = this.dataRequestForm.get('statusType') as FormControl;
  control.setValue([]); // Clear all
  this.statusIds = [];
  this.onAdvancedFilter();
}

onDateSelected() {
  this.onAdvancedFilter();
}

getSelectedFilterCount(): number {
    let count = 0;

    // Request Type filter
    const typeArray = this.dataRequestForm.get('categoryType').value;
    if (typeArray && typeArray.length > 0) {
      count++;
    }

    

    // Modified Date filter
    const updatedStart = this.updatedOn.get('startDate')?.value;
    const updatedEnd = this.updatedOn.get('endDate')?.value;
    if (updatedStart || updatedEnd) {
      count++;
    }

    // Status filter
    const statusArray = this.dataRequestForm.get('statusType')?.value;
    if (statusArray && statusArray.length > 0) {
      count++;
    }

    // Search filter
    const searchText = this.searchTerm;
    if (searchText && searchText.trim().length > 0) {
      count++;
    }

    return count;
  }
getFilterPayload(){
  let filterPayload = {
  userId:localStorage.getItem('userId'),
  searchText: this.searchTerm,
  headerId: this.headerIds,
  statusType: this.statusIds,
  updatedDate: {
          startDate: this.updatedOn.get('startDate')?.value ? formatDate(this.updatedOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
          endDate: this.updatedOn.get('endDate')?.value ? formatDate(this.updatedOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
        },
  sortBy: this.sortByValue,
  sortType: this.sortTypeValue,
}
return filterPayload;
}

onAdvancedFilter(){
  this.isAdvancedFilter = true;
  this.page = 1;
  this.getManageModuleDetailsList();
}
 getManageModuleDetailsList(){
   const filterValues = this.getFilterPayload();
   this.manageModuleService.onManageModuleDetailsFilter(filterValues,this.itemsPerPage,this.page).subscribe({
    next: (res: any) => {
      if (res?.code === 200) {
       this.filterData = res?.result ?? [];
       this.totalItems = res?.totalCount;
       this.pendingItemsCount = res?.pendingCount;
      }else {
        this.filterData = [];
        this.totalItems = 0;
      }
    },
    error: () => {
      this.filterData = [];
      this.totalItems = 0;
   }
  });
  }
getAllHeaderCategory() {
      this.userId = localStorage.getItem('userId');
      this.homePageService.onHeader(this.userId).subscribe((res: any) => {
      let categoryList= res.result;
      categoryList = categoryList.filter((item: any) => item.homePageItem === true && item.headerName !== "Insights");
      this.categoryOptions = categoryList;
    })
  }

getPage(event: any) {
  this.page = event;
  this.currentPage = this.page - 1;
  this.getManageModuleDetailsList();
}

  onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
       window.location.replace('/login');
    }else{
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }

onSort(column: string,i:any) {
    if (column === 'Updated On') {
      this.sortByValue = 'updated_date';
    }
    this.activeSortIndex = i;
    this.isAscending = !this.isAscending;
    this.sortTypeValue = this.isAscending ? 'asc' : 'desc';
    this.onAdvancedFilter();
}






}
